import {
    apiRequest,
    bankUpdate,
    bankDetail
} from "../../../../../services/adapters/master/bankService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", bankUpdate, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", bankDetail, {
            params: query
        }, true)
    }
}

export default UpdateRepository